export default __webpack_public_path__ + "static/media/tfg-img.183a8bec.webp";